import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function AdminUsers() {
  const [users, setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState('');
  const { getIdToken }      = useAuth();

  useEffect(() => { fetchUsers(); }, []);

  function fetchUsers() {
    const token = getIdToken();
    axios.get(`${API_URL}/api/users.json`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => { setUsers(res.data.users || []); setLoading(false); })
      .catch(() => { setError('Failed to load users.'); setLoading(false); });
  }

  async function toggleRole(user) {
    const newRole = user.role === 'admin' ? 'user' : 'admin';
    if (!window.confirm(`Change ${user.name}'s role to "${newRole}"?`)) return;
    const token = getIdToken();
    try {
      await axios.put(
        `${API_URL}/api/users/set-role.json?id=${user.id}`,
        { role: newRole },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUsers((prev) => prev.map((u) => u.id === user.id ? { ...u, role: newRole } : u));
    } catch {
      setError('Failed to update role.');
    }
  }

  if (loading) return <div style={s.loading}>Loading users...</div>;

  return (
    <div>
      <h2 style={s.pageTitle}>Manage Users</h2>
      {error && <div style={s.error}>{error}</div>}

      <div style={s.card}>
        <div style={s.tableHead}>
          <span>Name</span><span>Email</span><span>Role</span>
          <span>PR Credits</span><span>Guest Credits</span><span>Action</span>
        </div>
        {users.length === 0 ? (
          <div style={s.empty}>No users found.</div>
        ) : users.map((u) => (
          <div key={u.id} style={s.tableRow}>
            <span style={s.name}>{u.name}</span>
            <span style={s.email}>{u.email}</span>
            <span>
              <span style={{ ...s.roleBadge, ...(u.role === 'admin' ? s.roleAdmin : s.roleUser) }}>
                {u.role}
              </span>
            </span>
            <span style={s.cell}>{u.prCredits}</span>
            <span style={s.cell}>{u.guestCredits}</span>
            <span>
              <button
                onClick={() => toggleRole(u)}
                style={{ ...s.roleBtn, ...(u.role === 'admin' ? s.roleBtnDemote : s.roleBtnPromote) }}
              >
                {u.role === 'admin' ? 'Demote' : 'Make Admin'}
              </button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  pageTitle: { margin: '0 0 1.5rem', fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  loading: { textAlign: 'center', padding: '3rem', color: '#888' },
  empty: { textAlign: 'center', padding: '2rem', color: '#888' },
  error: { background: '#fee', border: '1px solid #fcc', padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem', color: '#c00', fontSize: '0.9rem' },
  card: { background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' },
  tableHead: { display: 'grid', gridTemplateColumns: '1fr 1.5fr 90px 90px 100px 110px', padding: '0.7rem 1.25rem', background: '#f8f8f8', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', color: '#999', borderBottom: '1px solid #eee' },
  tableRow: { display: 'grid', gridTemplateColumns: '1fr 1.5fr 90px 90px 100px 110px', padding: '0.9rem 1.25rem', borderBottom: '1px solid #f0f0f0', alignItems: 'center' },
  name: { fontWeight: 600, fontSize: '0.875rem', color: '#1a1a2e' },
  email: { fontSize: '0.82rem', color: '#555' },
  cell: { fontSize: '0.875rem', color: '#555' },
  roleBadge: { fontSize: '0.72rem', fontWeight: 700, padding: '0.2rem 0.55rem', borderRadius: 20, textTransform: 'uppercase' },
  roleAdmin: { background: '#fef3c7', color: '#b45309' },
  roleUser: { background: '#f3f4f6', color: '#6b7280' },
  roleBtn: { padding: '0.3rem 0.7rem', border: 'none', borderRadius: 4, fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer' },
  roleBtnPromote: { background: '#dbeafe', color: '#1d4ed8' },
  roleBtnDemote: { background: '#fee2e2', color: '#dc2626' },
};
